// Social Skills Options (hardcoded from database)
export const socialSkillOptions = [
    { value: '49e333c5-01f0-4311-9f20-d75b7a8356d6', label: 'Fair Play', sortIndex: 1 },
    { value: 'e0232410-538b-458c-836f-3f4adad1ddde', label: 'On Time', sortIndex: 2 },
    { value: 'eafe3c13-c06a-4a34-8bdf-321f72d7880f', label: 'Chill', sortIndex: 3 },
    { value: '093b3660-06a5-4aec-b518-2bbe61da5ba3', label: 'Friendly', sortIndex: 4 },
    { value: 'f2977742-de02-40c6-8f40-721e3efeb770', label: 'Teamwork', sortIndex: 5 }
];

export const createSocialSkillOptions = (t: any, originalOptions: any[]) => 
    originalOptions.map(option => ({
        ...option,
        label: t(`socialSkills.${option.label.toLowerCase().replace(' ', '')}`) || option.label
    }));

export interface SocialSkillOption {
    value: string;
    label: string;
    sortIndex: number;
}